// src/SearchPage.jsx
import React, { useState, useEffect } from "react";

export default function SearchPage() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = async (searchQuery = query) => {
    setError("");
    setResults({});
    setLoading(true);

    try {
      const res = await fetch(
        `https://gravitechinstitute.com/certificate/search_certificates.php?query=${encodeURIComponent(searchQuery)}`
      );
      const data = await res.json();
      setLoading(false);

      if (data.results) {
        setResults(data.results);
      } else {
        setError("No results found.");
      }
    } catch (err) {
      setLoading(false);
      setError("Error fetching data.");
    }
  };

  // ⏳ Auto-search on load if URL contains ?certificate=xxxx
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const paramQuery = params.get("certificate");

  if (paramQuery) {
    setQuery(paramQuery);

    const fetchResults = async () => {
      setError("");
      setResults({});
      setLoading(true);

      try {
        const res = await fetch(
          `https://gravitechinstitute.com/certificate/search_certificates.php?query=${encodeURIComponent(paramQuery)}`
        );
        const data = await res.json();
        setLoading(false);

        if (data.results) {
          setResults(data.results);
        } else {
          setError("No results found.");
        }
      } catch (err) {
        setLoading(false);
        setError("Error fetching data.");
      }
    };

    fetchResults();
  }
}, []);


  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto", fontFamily: "'Segoe UI', sans-serif" }}>
      <h2 style={{ marginBottom: "20px", color: "#2e317d" }}>🔍 Certificate Verification</h2>

      <div style={{ display: "flex", gap: "10px", marginBottom: "30px" }}>
        <input
          type="text"
          placeholder="Enter Name or Certificate Number"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{
            flex: 1,
            padding: "12px",
            fontSize: "16px",
            border: "1px solid #ccc",
            borderRadius: "6px",
          }}
        />
        <button
          onClick={() => handleSearch()}
          disabled={!query.trim()}
          style={{
            padding: "12px 20px",
            backgroundColor: "#2e317d",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: query.trim() ? "pointer" : "not-allowed",
          }}
        >
          🔍 Search
        </button>
      </div>

      {loading && <p>Searching...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {Object.keys(results).map((name, idx) => (
        <div
          key={idx}
          style={{
            marginBottom: "30px",
            padding: "20px",
            background: "#f7f9fc",
            borderRadius: "10px",
            border: "1px solid #ddd",
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          }}
        >
          <h3 style={{ margin: "0 0 10px 0", color: "#1a237e" }}>{name}</h3>
          <p style={{ margin: "0 0 15px 0", fontWeight: "bold", color: "#333" }}>
            Certificates issued:
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {results[name].map((cert, i) => (
              <div
                key={i}
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "12px 16px",
                  lineHeight: 1.6,
                }}
              >
                <div style={{ fontWeight: "bold", color: "#2e317d", fontFamily: "monospace" }}>
                  {cert.certificate_number}
                </div>
                <div style={{ fontSize: "14px", color: "#555" }}>
                  <strong>Method:</strong> {cert.method} &nbsp;|&nbsp;
                  <strong>Exam:</strong> {cert.exam_date} &nbsp;|&nbsp;
                  <strong>Issued:</strong> {cert.issued_date} &nbsp;|&nbsp;
                  <strong>Valid Upto:</strong> {cert.valid_upto}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {Object.keys(results).length === 0 && query && !loading && !error && (
        <p style={{ color: "#777" }}>No certificates found for “{query}”.</p>
      )}

      <footer style={{
        textAlign: "center",
        padding: "10px",
        fontSize: "14px",
        borderTop: "1px solid #f2f2f2",
        color: "#555",
        marginTop: "3rem"
      }}>
        &copy; {new Date().getFullYear()} Gravitech Institute. Developed by{" "}
        <a
          href="https://its.net.in/"
          target="_blank"
          rel="noopener noreferrer"
          title="ITS - Info Twist Solutions"
          style={{ color: "#2e317d", textDecoration: "none" }}
        >
          ITS
        </a>
      </footer>
    </div>
  );
}
